import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCta() {
  return <section id="cta-final" className="w-full bg-navy-900 px-4 py-14 text-white sm:py-20" data-id="element-156" data-mp="1nprgi2qh9xq4">
      <div className="mx-auto max-w-xl" data-id="element-157" data-mp="1snaxvbih2qma">
        <h2 className="text-center font-display text-[26px] font-bold leading-[1.15] tracking-tight sm:text-4xl" data-id="element-158" data-mp="1sm89ba8mh09j">
          Tu próximo gran diagnóstico no depende de memorizar más información
        </h2>

        <div className="mt-5 space-y-3.5 text-center text-[15px] leading-relaxed text-white/75 sm:text-[17px]" data-id="element-159" data-mp="1inseaw6h56ur">
          <p data-id="element-160" data-mp="14sgmawjpduhj">
            Depende de contar con un proceso que te indique qué observar, en qué orden hacerlo y cómo
            convertir cada hallazgo en una decisión clínica respaldada por un método.
          </p>
          <p data-id="element-161" data-mp="342zlm53jvto5">
            Diagnostica con mayor seguridad en solo 15 minutos gracias al{' '}
            <strong className="font-semibold text-white" data-id="element-162" data-mp="294tbre77plb">Sistema de Diagnóstico Facial</strong>, el
            método paso a paso que integra el análisis del rostro con la cefalometría para respaldar
            cada decisión clínica.
          </p>
          <p className="font-semibold text-gold-300" data-id="element-163" data-mp="b058ksdjf305">
            Empieza hoy y aplica el sistema en tu próximo paciente.
          </p>
        </div>

        <div className="mt-8 rounded-3xl border border-white/10 bg-white/5 p-5 sm:p-6" data-id="element-164" data-mp="3ffn0xkgarw0z">
          <ScarcityBar spotsLeft={9} totalSpots={120} tone="dark" data-id="element-165" data-mp="3fhhnf377vw76" />

          <div className="mt-5" data-id="element-166" data-mp="3ai4vi41hnyxq">
            <CtaButton label="Quiero el Sistema de Diagnóstico Facial por $12.99 USD" location="cta_final" data-id="element-167" data-mp="3ogbhomx2sahk" />
            <p className="mt-3 text-center text-[11.5px] font-medium leading-relaxed text-white/60 sm:text-sm" data-id="element-168" data-mp="3jggscnsy7sym">
              Descarga inmediata • Acceso de por vida • Pago único • Garantía de 7 días
            </p>
          </div>

          <div className="mt-4" data-id="element-169" data-mp="yt3sqg6mc3fa">
            <Countdown label="Tu precio promocional expira en" tone="dark" data-id="element-170" data-mp="3sjind7qb8yyh" />
          </div>

          <p className="mt-4 flex items-center justify-center gap-2 text-center text-[11.5px] font-medium leading-snug text-white/60" data-id="element-171" data-mp="1cfxqkq4f0qd">
            <GlobeIcon className="h-4 w-4 shrink-0 text-gold-300" aria-hidden="true" data-id="element-172" data-mp="5fkyahqn4scd" />
            Cambio de moneda automático según tu país.
          </p>
        </div>
      </div>
    </section>;
}